import React from "react";
import ModalFormObserva from "./ModalFormObserva";

const ModalObserva = ({ show, handleClose, observa }) => {
  return (
    <ModalFormObserva show={show} handleClose={handleClose} observa={observa} />
  );
};

export default ModalObserva;
